 // Free Gift Product
 $(document).ready(function() {


 	$('.free-gifts-properties-js').empty();

 	$('form.free-gifts-form.active input.js-product_id_input:not(:disabled)').each(function(index, data) {
 		var value = $(this).val();
 		var newInput = `<input type="hidden" name="properties[_free gift ${index}]" value= "${value}">`;
 		console.log(newInput);
 		$('.free-gifts-properties-js').append(newInput);

 	});




 	function isCart() {
 		if (document.URL.includes("/cart")) return true;
 		else false;
 	}

 	$(document).on("click", ".link.main-product--true", function(event) {
 		event.preventDefault();
 		const $this = $(this);

 		let $loader = $this.closest('.line-item__content-wrapper').find(".line-item__loader");
 		let $spinner = $loader.find(".line-item__loader-spinner");
 		let $checkMark = $loader.find(".line-item__loader-mark");

 		$loader.removeAttr("hidden");
 		$spinner.removeAttr("hidden");

 		const updates = {};
 		updates[$this.data("line-id")] = 0;

 		if (isCart()) {
 			$this.parents(".cart-line-item").find(".list-disc input.freegiftId").each(function() {
 				updates[$(this).val()] = 0;
 			});
 		} else {
 			$this.closest(".line_item_content").find(".product-item-meta__property input.freegiftId").each(function() {
 				updates[$(this).val()] = 0;
 			});
 		}

 		fetch(window.Shopify.routes.root + "cart/update.js", {
 				method: "POST",
 				headers: {
 					"Content-Type": "application/json",
 				},
 				body: JSON.stringify({
 					updates
 				}),
 			})
 			.then(response => response.json())
 			.then(dataResponse => {
 				let itemCount = dataResponse.item_count;

 				if (isCart()) {
 					location.reload();
 				} else {
 					$spinner.attr("hidden", "");
 					$checkMark.removeAttr("hidden");
 					setTimeout(() => {
 						$loader.attr("hidden", "");
 						$spinner.attr("hidden", "");
 						$checkMark.attr("hidden", "");
 					}, 1000);
 					document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 						bubbles: true
 					}));
 				}
 			})
 			.catch(error => {
 				console.error("Error:", error);
 			});

 	});


 	function increaseQuantity(event) {
 		var updates = {
 			"updates": {}
 		};
 		var $currentLineItem = $(event).closest('.line-item');
 		let $loader = $currentLineItem.find(".line-item__loader");
 		let $spinner = $loader.find(".line-item__loader-spinner");
 		let $checkMark = $loader.find(".line-item__loader-mark");
 		$loader.removeAttr("hidden");
 		$spinner.removeAttr("hidden");
 		var $metaProperties = $currentLineItem.find('.line-item__info');
 		var $quantityInput = $currentLineItem.find('.quantity-selector__input');

 		var quantity = parseInt($quantityInput.val()) + 1;
 		$quantityInput.val(quantity);

 		updates.updates[$(event).data('line-id')] = quantity;

 		if ($metaProperties.find('input.freegiftId').length > 0) {
 			$metaProperties.find('input.freegiftId').each(function(index, data) {
 				let vId = $(this).val();
 				updates.updates[vId] = quantity;
 			});
 		}

 		cartUpdated(updates);
 	}

 	function decreaseQuantity(event) {
 		var updates = {
 			"updates": {}
 		};
 		var $currentLineItem = $(event).closest('.line-item');
 		let $loader = $currentLineItem.find(".line-item__loader");
 		let $spinner = $loader.find(".line-item__loader-spinner");
 		let $checkMark = $loader.find(".line-item__loader-mark");
 		$loader.removeAttr("hidden");
 		$spinner.removeAttr("hidden");

 		var $metaProperties = $currentLineItem.find('.line-item__info');
 		var $quantityInput = $currentLineItem.find('.quantity-selector__input');
 		var quantity = parseInt($quantityInput.val()) - 1;
 		if (quantity < 0) {
 			quantity = 0;
 		}
 		$quantityInput.val(quantity);

 		updates.updates[$(event).data('line-id')] = quantity;

 		if ($metaProperties.find('input.freegiftId').length > 0) {
 			$metaProperties.find('input.freegiftId').each(function(index, data) {
 				let vId = $(this).val();
 				updates.updates[vId] = quantity;
 			});
 		}

 		cartUpdated(updates);
 	}


 	function cartUpdated(updates) {
 		fetch(window.Shopify.routes.root + 'cart/update.js', {
 				method: 'POST',
 				headers: {
 					'Content-Type': 'application/x-www-form-urlencoded'
 				},
 				body: $.param(updates)
 			})
 			.then(response => {
 				if (response.ok) {
 					return response.json().then(dataResponse => {
 						let itemCount = dataResponse.item_count;

 						if (isCart()) {
 							location.reload();
 						} else {
 							document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 								bubbles: true
 							}));

 						}

 						$('.cart-drawer.cart-drawer').removeClass('cart_loading');
 					});
 				} else {
 					console.log(response);
 					$('.cart-drawer.cart-drawer').removeClass('cart_loading');
 					throw new Error('Error updating cart');
 				}
 			})
 			.catch((error) => {
 				$('.cart-drawer.cart-drawer').removeClass('cart_loading');
 				console.error('Error:', error);
 			});
 	}

 	$(document).on('click', '.quantity-selector__button.minus', function(event) {
 		event.preventDefault();
 		decreaseQuantity($(this));
 	});

 	$(document).on('click', '.quantity-selector__button.plus', function(event) {
 		event.preventDefault();
 		increaseQuantity($(this));
 	});




 });


 $(document).ready(function() {
 	const productVariantElement = document.querySelector('product-variants');
 	let PreselectedVariantId = $('product-variants').attr('preselected_id');
 	PreselectedVariantId = parseInt(PreselectedVariantId);
 	// if (PreselectedVariantId) {
 	// 	productVariantElement.selectVariant(PreselectedVariantId);
 	// }
	setTimeout(function () {
		if (PreselectedVariantId && productVariantElement) {
			productVariantElement.selectVariant(PreselectedVariantId);
		}
	}, 500);
 });

 function openCity(evt, cityName) {
 	var i, tabcontent, tablinks;
 	tabcontent = document.getElementsByClassName("tabcontent");
 	for (i = 0; i < tabcontent.length; i++) {
 		tabcontent[i].style.display = "none";
 	}
 	tablinks = document.getElementsByClassName("tablinks");
 	for (i = 0; i < tablinks.length; i++) {
 		tablinks[i].className = tablinks[i].className.replace(" active", "");
 	}
 	document.getElementById(cityName).style.display = "block";
 	evt.currentTarget.className += " active";
 }
 $(document).ready(function() {
 	if ($(".customer_main").length > 0) {
 		$('.customer_main').slick({
 			slidesToShow: 3,
 			dots: true,
 			arrows: true,
 			responsive: [{
 					breakpoint: 991,
 					settings: {
 						slidesToShow: 2,
 					}
 				},
 				{
 					breakpoint: 799,
 					settings: {
 						slidesToShow: 1,
 					}
 				}
 			]
 		});
 	}
 });

 $(document).ready(function() {
 	if ($(".tried-tested-video").length > 0) {
 		$('.tried-tested-video').slick({
 			slidesToShow: $('.tested-video-wrapper').attr('data-viewItem') || 4,
 			dots: false,
 			arrows: false,
 			centerMode: false,
 			infinite: true,
 			responsive: [{
 					breakpoint: 998,
 					settings: {
 						slidesToShow: 4,
 						slidesToScroll: 1,
 					},
 				},
 				{
 					breakpoint: 789,
 					settings: {
 						slidesToShow: 3,
 						slidesToScroll: 1,
 						centerMode: false,
 					},
 				}
 			],
 		});
 	}

 	function progressBar(progress) {
 		if (progress == 0) {
 			progress = 10;
 		}
 		var progressBar = $('.progress-bar__inner');
 		progressBar.css('width', progress + '%');
 	}

 	progressBar(10);

 	$('.tried-tested-video').on('beforeChange', function(event, slick, currentSlide, nextSlide) {

 		var calc = ((nextSlide) / (slick.slideCount - 1)) * 100;
 		progressBar(calc);
 	});

 	$(document).on("click", ".tried-tested-video .video-control", function() {

 		var clickedControl = $(this);
 		var clickedVideo = clickedControl.closest('.popup-video').find('video')[0];
 		var videoHtml = clickedControl.closest('.video-item').html();

 		// Move the video to the main popup
 		$('.tested-main-popup').html(videoHtml);

 		// Pause all other videos
 		$('.popup-video video').not(clickedVideo).each(function() {
 			this.pause();
 			$(this).siblings('.video-control').removeClass('btnhide');
 		});

 		// Toggle play/pause and update control icon for the video in the main popup
 		var mainPopupVideo = $('.tested-main-popup video')[0];
 		if (mainPopupVideo.paused) {
 			mainPopupVideo.play();
 			$('.tested-main-popup .video-control').addClass('btnhide');
 		} else {
 			mainPopupVideo.pause();
 			$('.tested-main-popup .video-control').removeClass('btnhide');
 		}

 		// Activate the main popup
 		$('.tested-main-popup').addClass('video-active');
 		$('body').addClass('video-popup-active');
 	});

 	$(document).on("click", ".tested-main-popup .icon-close", function() {
 		// Pause and close the video in the main popup
 		var mainPopupVideo = $('.tested-main-popup video')[0];
 		if (mainPopupVideo) {
 			mainPopupVideo.pause();
 			$('.tested-main-popup .video-control').removeClass('btnhide');
 		}

 		$('body').removeClass('video-popup-active');
 		$('.tested-main-popup').removeClass('video-active');
 		$('.tested-main-popup').empty();
 	});

 	$(document).on("click", ".tested-main-popup .icon-volume", function() {
 		console.log("this = ", this);
 		var mainPopupVideo = $(this).parents('.tested-main-popup').find('video')[0];
 		console.log("mainPopupVideo", mainPopupVideo);
 		if (mainPopupVideo) {
 			mainPopupVideo.muted = !mainPopupVideo.muted;
 			$(this).toggleClass("volume-muted", mainPopupVideo.muted);
 		}
 	});

 });

 $(document).ready(function() {

 	function isInViewport(theDiv) {
 		let elementTop = theDiv.offset().top;
 		let elementBottom = elementTop + theDiv.outerHeight();
 		let viewportTop = $(window).scrollTop();
 		let viewportBottom = viewportTop + window.innerHeight;
 		return elementBottom > viewportTop && elementTop < viewportBottom;
 	}
 	var animationDone = false;
 	if ($('#product-block-tested').length) {
 		$(window).on('scroll', function() {
 			if (!animationDone) {
 				if (isInViewport($('#product-block-tested'))) {
 					animationDone = true;
 					$(".circleBarProgress").each(function() {
 						var t = $(this).find(".circleBar"),
 							x = $(this).find(".circleBarWrapper"),
 							i = $(this).find("span"),
 							e = parseInt(i.text(), 10);
 						$({
 							p: 0
 						}).animate({
 							p: e
 						}, {
 							duration: 3e3,
 							easing: "swing",
 							step: function(e) {
 								x.css({
 									background: "conic-gradient(#FF6C84 0deg " + e + "%, #FEEAE8 " + e + "%)"
 								}), i.text(0 | e);

 							},
 						});
 					});
 				}
 			}
 		});
 	}
 });

 $("a").on('click', function(event) {
 	if ($(this).hasClass('redirect_rewart') == false) {
 		if ($(this).hasClass('shg-btn') == false && $(this).hasClass('redirect_rewart') == false) {
 			if (this.hash !== "") {
 				event.preventDefault();
 				var hash = this.hash;
 				$('html, body').animate({
 					scrollTop: $(hash).offset().top
 				}, 1000, function() {});
 			} // End if
 		}
 	}
 });

 // Add smooth scrolling to all links
 $("a").on('click', function(event) {
 	if ($(this).hasClass('shg-btn') == false && $(this).hasClass('redirect_rewart') == false) {
 		// Make sure this.hash has a value before overriding default behavior
 		if (this.hash !== "") {
 			// Prevent default anchor click behavior
 			event.preventDefault();

 			// Store hash
 			var hash = this.hash;

 			// Using jQuery's animate() method to add smooth page scroll
 			// The optional number (800) specifies the number of milliseconds it takes to scroll to the specified area
 			$('html, body').animate({
 				scrollTop: $(hash).offset().top - 120
 			}, 800, function() {

 				// Add hash (#) to URL when done scrolling (default click behavior)
 				// window.location.hash = hash;
 			});
 		} // End if
 	}
 });

 if ($('.custom-gallery-instafeed').length) {
 	$('.custom-gallery-instafeed').slick({
 		slidesToShow: 6,
 		dots: false,
 		arrows: false,
 		centerMode: false,
 		responsive: [{
 				breakpoint: 998,
 				settings: {
 					slidesToShow: 4,
 					slidesToScroll: 1,
 				},
 			},
 			{
 				breakpoint: 789,
 				settings: {
 					slidesToShow: 3,
 					slidesToScroll: 1,
 					centerMode: false,
 				},
 			},
 			{
 				breakpoint: 543,
 				settings: {
 					slidesToShow: 3,
 					slidesToScroll: 1,
 					centerMode: false,
 				},
 			}
 		],
 	});
 }

 if ($('.custom-instafeed-slider').length) {
 	$(".custom-instafeed-slider").slick({
 		arrows: false,
 		dots: false,
 		slidesToShow: 6,
 		centerMode: true,
 		centerPadding: '100px',
 		responsive: [{
 				breakpoint: 1024,
 				settings: {
 					slidesToShow: 4,
 					centerPadding: '50px',
 				}
 			},
 			{
 				breakpoint: 769,
 				settings: {
 					slidesToShow: 3,
 					centerPadding: '0px',
 				}
 			},
 			{
 				breakpoint: 480,
 				settings: {
 					slidesToShow: 2,
 					centerPadding: '30px',
 				}
 			},
 		]
 	});
 }

 //   $(document).on('click', '.collection-menu-item', function() {
 //   $(this).addClass('link-active');      
 //   $(this).siblings().removeClass('link-active');
 //   var dataTab = $(this).data('tab');
 //   $('.custom-collection-template .custom-collection-tab .product-item').hide();
 //   $('.custom-collection-template .custom-collection-tab .product-item.'+dataTab+'').show();

 //  var activeText = $(this).text();
 //   console.log(activeText);
 //   $('.collection-title').text(activeText);
 // });

 $(document).on('click', '.grid_list_item .item_list', function() {
 	$(this).addClass('active');
 	$(this).siblings().removeClass('active');
 	$('.product-list__inner').addClass('product_list_view');
 });

 $(document).on('click', '.grid_list_item .item_grid', function() {
 	$(this).addClass('active');
 	$(this).siblings().removeClass('active');
 	$('.product-list__inner').removeClass('product_list_view');
 });

 // Product slider
 var $slider = $('.product-slider-section .slider-product-wrapper');
 var $progressBar = $('.progress__bar, .progress__bar_item');
 var $progressBarLabel = $('.slider__label');

 // Set initial background size and aria-valuenow
 $progressBar.css('background-size', '2% 100%').attr('aria-valuenow', 2);

 $slider.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
 	var calc = ((nextSlide) / (slick.slideCount - 1)) * 100;

 	if (calc === 0) {
 		$progressBar.css('background-size', '2% 100%').attr('aria-valuenow', 2); // Set background size to 2% if next slide is the first one
 	} else {
 		$progressBar.css('background-size', calc + '% 100%').attr('aria-valuenow', calc);
 	}

 	$progressBarLabel.text(calc + '% completed');
 });

 $slider.slick({
 	slidesToShow: 3,
 	slidesToScroll: 1,
 	arrows: true,
 	speed: 400,

 	appendArrows: '.slider-nav',
 	infinite: true, // Enable infinite looping
 	responsive: [{
 			breakpoint: 1200,
 			settings: {
 				slidesToShow: 2,
 				slidesToScroll: 1,
 			},
 		},
 		{
 			breakpoint: 789,
 			settings: {
 				slidesToShow: 2,
 				adaptiveHeight: false,
 				slidesToScroll: 1,
 			},
 		},
 	],
 });

 $(document).on('click', '.purchase-details__buttons .product-form__add-button', function(e) {
 	e.preventDefault();
 	var $this = $(this);
 	$this.attr("disabled", true);
 	$this.append("<div class='custom_loader'></div>");
 	$this.find('span').hide();
 	$this.find('.add-icon').hide();
 	let upsellId = $this.closest('form').find('input[name=id]').val();
 	if (upsellId) {
 		$.ajax({
 			type: 'POST',
 			url: '/cart/add.js',
 			data: {
 				quantity: 1,
 				id: upsellId
 			},
 			dataType: 'json',
 			success: function(data) {
 				document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 					bubbles: true
 				}));
 				if (!document.getElementById('mini-cart').open == true) {
 					document.getElementById('mini-cart').open = true;
 				}
 				setTimeout(
 					function() {
 						$this.find('span').show();
 						$(".custom_loader").remove();
 						$this.attr("disabled", false);
 					}, 500);
 				shippingInsuranceAddRemove();
 			},
 			error: function(XMLHttpRequest) {
 				var response = eval('(' + XMLHttpRequest.responseText + ')');
 				if (response) {
 					response = response.description;
 					$('.warning').remove();
 					var warning = '<p class="warning animated bounceIn">' + response.replace('All 1 ', 'All ') + '</p>';
 					$this.after(warning);
 				}
 			}
 		});
 	}

 });

 document.addEventListener("DOMContentLoaded", function() {
 	let clock;

 	function setTheCookie(name, value, days) {
 		let expires = "";
 		if (days) {
 			let date = new Date();
 			date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
 			expires = "; expires=" + date.toUTCString();
 		}
 		document.cookie = name + "=" + value + expires + "; path=/";
 	}

 	function getTheCookie(name) {
 		let nameEQ = name + "=";
 		let ca = document.cookie.split(';');
 		for (let i = 0; i < ca.length; i++) {
 			let c = ca[i];
 			while (c.charAt(0) === ' ') c = c.substring(1, c.length);
 			if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
 		}
 		return null;
 	}


 	if (getTheCookie("countdownTimer_collection") !== "" || getTheCookie("countdownTimer_collection") !== null) {
 		console.log("time is alrea there =====================", getTheCookie("countdownTimer_collection"));
 	} else {
 		setTheCookie("countdownTimer_collection", 10, 1);
 		console.log("first tme set time =====================");
 	}

 	function startClock(initialTimerValue) {
 		clock = new FlipClock($(".clock_timer"), initialTimerValue, {
 			clockFace: "HourlyCounter",
 			countdown: true,
 			autoStart: true,
 			callbacks: {
 				stop: function() {
 					console.log("Timer has ended!");
 					// Restart the clock after it ends
 					clearCookie('countdownTimer_collection');
 					clearInterval(intervalId);
 					initialTimerValue = (2 * 60 + 13) * 60;
 					startClock(initialTimerValue);
 				},
 			},
 		});
 	}

 	function clearCookie(name) {
 		document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
 	}

 	// Get the user's current time zone offset in minutes
 	let userTimeZoneOffset = moment().utcOffset() / 60;

 	// Set the reset time to 23:59:59 in the user's timezone
 	let currentDate = moment().utcOffset(userTimeZoneOffset);
 	let resetTime = currentDate.clone().endOf('day').hour(23).minute(59).second(59).unix();
 	let currentTime = moment().unix();
 	let diff = resetTime - currentTime;

 	if (diff <= 0) {
 		// If the time has passed for the day, set the reset time for the next day
 		resetTime += 24 * 60 * 60; // Add 24 hours in seconds
 		diff = resetTime - currentTime;
 	}

 	var savedTimerValue = getTheCookie("countdownTimer_collection");
 	console.log("save value ============================= ", savedTimerValue);

 	// Set the countdown timer to 2 hours and 13 minutes (2 hours * 60 minutes + 13 minutes)
 	let initialTimerValue = savedTimerValue ? parseInt(savedTimerValue) : (2 * 60 + 13) * 60;

 	// Run countdown timer
 	startClock(initialTimerValue);

 	// Save the remaining time in the cookie every second
 	intervalId = setInterval(function() {
 		setTheCookie("countdownTimer_collection", clock.getTime().time, 1);
 	}, 1000);



 });

 function calculateProgress(currentVal, targetVal) {
 	var progressBar = document.querySelectorAll('.cart-shippingThreshold__progress');
 	var progressNum = document.querySelectorAll('.cart-shipping__num');
 	var progressOuter = document.querySelectorAll('.cart-shipping__numOuter');
 	var successMsg = document.querySelectorAll('.cart-shipping__success');
 	var result = Math.round(100 * currentVal / targetVal);
 	if (result <= 100) {
 		progressBar.forEach(function(el) {
 			// el.setAttribute('style', "width: ".concat(result, "%"));
 			el.setAttribute('style', 'width: 100%;');
 		})
 		$(".shipping-percentage-circle").text(result + "%");
 		$(".shipping-percentage-circle").css('left', 'calc(' + result + '% - 25px)');
 		// $(".shipping-percentage-circle").css('left', '-=25px');
 	} else {
 		progressBar.forEach(function(el) {
 			el.setAttribute('style', 'width: 100%;');
 		})
 		$(".shipping-percentage-circle").html('<img src="{{ "checkmark.png" | file_img_url: "master" }}" />');

 		$(".shipping-percentage-circle").css("left", "calc(100% - 25px)");
 	}
 	var newProgressNum = (targetVal - currentVal) / 100;
 	if (newProgressNum <= 0) {
 		successMsg.forEach(function(el) {
 			el.setAttribute('style', 'display: block;');
 		});
 		progressOuter.forEach(function(el) {
 			el.setAttribute('style', 'display: none;');
 		});
 		progressNum.forEach(function(el) {
 			el.textContent = newProgressNum;
 		});
 	} else {
 		successMsg.forEach(function(el) {
 			el.setAttribute('style', 'display: none;');
 		});
 		progressOuter.forEach(function(el) {
 			el.setAttribute('style', 'display: block;');
 		});
 		progressNum.forEach(function(el) {
 			el.textContent = newProgressNum;
 		});
 	}
 };

 function freeSample(cart) {
 	let freeSampleId = Shopify.freeSampleId;
 	if (!cart.items.length) return false
 	const freeSampleInCart = cart.items.some(item => item.id == freeSampleId)
 	if (cart.items.length == 1 && freeSampleInCart) {
 		freeSampleRemove()
 	}
 	if (cart.items.length != 0 && !freeSampleInCart) {
 		freeSampleAddToCart(freeSampleId)
 	}

 	function freeSampleAddToCart(id) {
 		$.ajax({
 			type: 'POST',
 			async: false,
 			url: '/cart/add.js',
 			dataType: 'json',
 			data: {
 				id: id,
 				quantity: 1
 			},
 			success: function() {
 				if (Shopify.template == 'cart') {
 					window.location.href = '/cart'
 				}
 			}
 		});
 	}

 	function freeSampleRemove() {
 		$.ajax({
 			type: 'POST',
 			async: false,
 			url: '/cart/clear.js',
 			dataType: 'json',
 			success: function() {
 				if (Shopify.template == 'cart') {
 					window.location.href = '/cart'
 				}
 			}
 		});
 	}
 }

 // Product page JS

 $(document).ready(function() {
 	if ($(".product_custmer_review .review_main").length > 0) {
 		$(".product_custmer_review .review_main").slick({
 			infinite: true,
 			slidesToShow: 3,
 			slidesToScroll: 1,
 			responsive: [{
 					breakpoint: 767,
 					settings: {
 						slidesToShow: 2,
 						slidesToScroll: 1,
 					}
 				},
 				{
 					breakpoint: 575,
 					settings: {
 						slidesToShow: 1,
 						slidesToScroll: 1,
 					}
 				}
 			]
 		});
 	}


 	$('.alternate-image-wrapper').slick({
 		slidesToShow: 1,
 		dots: true,
 		arrows: false
 	});

 	var interval_2 = setInterval(function() {
 		if (document.querySelector(".heading.solution-products")) {
 			$(".heading.solution-products").slick({
 				dots: false,
 				infinite: false,
 				arrows: true,
 				speed: 500,
 				slidesToShow: 3.3,
 				slidesToScroll: 3,
 				responsive: [{
 						breakpoint: 1024,
 						settings: {
 							slidesToShow: 3.3,
 							slidesToScroll: 1,
 							infinite: true
 						}
 					},
 					{
 						breakpoint: 799,
 						settings: {
 							slidesToShow: 2,
 							slidesToScroll: 1,
 							infinite: true
 						}
 					},
 					{
 						breakpoint: 600,
 						settings: {
 							slidesToShow: 1,
 							slidesToScroll: 1,
 							infinite: true
 						}
 					},
 					{
 						breakpoint: 480,
 						settings: {
 							slidesToShow: 1,
 							slidesToScroll: 1,
 							infinite: true
 						}
 					},
 				],
 			});
 			clearInterval(interval_2);
 		}
 	}, 500);

 	var interval = setInterval(function() {
 		if (document.querySelector(".products_recomendation")) {
 			$(".products_recomendation .cart-recomendation-product").slick({
 				dots: false,
 				infinite: false,
 				arrows: true,
 				speed: 500,
 				slidesToShow: 3.3,
 				slidesToScroll: 3,
 				responsive: [{
 						breakpoint: 1024,
 						settings: {
 							slidesToShow: 3.3,
 							slidesToScroll: 1,
 							infinite: true
 						}
 					},
 					{
 						breakpoint: 799,
 						settings: {
 							slidesToShow: 2,
 							slidesToScroll: 1,
 							infinite: true
 						}
 					},
 					{
 						breakpoint: 600,
 						settings: {
 							slidesToShow: 1,
 							slidesToScroll: 1,
 							infinite: true
 						}
 					},
 					{
 						breakpoint: 480,
 						settings: {
 							slidesToShow: 1,
 							slidesToScroll: 1,
 							infinite: true
 						}
 					},
 				],
 			});
 			clearInterval(interval);
 		}
 	}, 500);


 	$('.faq-question').click(function() {
 		$(this).siblings().slideToggle().parents('.product-faq-item').toggleClass('active');
 		$(this).parents('.product-faq-item').siblings().removeClass('active').find('.faq-answer').slideUp();
 	});

 	$('.ques-heading').click(function(j) {

 		var dropDown = $(this).closest('.questions__item_row').find('.ques-desc');
 		$(this).closest('.question-body').find('.ques-desc').not(dropDown).slideUp();

 		if ($(this).hasClass('qs_active')) {
 			$(this).removeClass('qs_active');
 		} else {
 			$('.ques-heading.qs_active').removeClass('qs_active');
 			$(this).addClass('qs_active');
 		}

 		dropDown.stop(false, true).slideToggle();
 		j.preventDefault();
 	});

 	$(".collapsible__btn").click(function() {
 		$(".collapsible__text_inside").slideToggle(350);
 	});

 });

 $(document).on('click', '.upsell-btn-js', function(e) {
 	e.preventDefault();
 	var $this = $(this);
 	$this.find('span.add-text').hide();
 	$this.append("<div class='custom_loader'></div>");
 	let upsellId = $(this).attr('variant__id');
 	if (upsellId) {
 		$.ajax({
 			type: 'POST',
 			url: '/cart/add.js',
 			data: {
 				quantity: 1,
 				id: upsellId
 			},
 			dataType: 'json',
 			success: function(data) {
 				document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 					bubbles: true
 				}));

 				setTimeout(
 					function() {
 						$this.find('span.added-text').fadeIn();
 						$this.removeClass('upsell-btn-js');
 						$(".custom_loader").remove();
 						// $this.closest('.bundle--inner_content').addClass('hide');
 					}, 1000);
 				shippingInsuranceAddRemove();
 			}
 		});
 	}

 });
 $(document).on('click', '.action_button.add_to_cart', function(e) {
 	e.preventDefault();
 	var $this = $(this);
 	$this.append("<div class='custom_loader'></div>");
 	$this.find('span').hide();
 	let upsellId = $this.closest('form').find('input[name=id]').val();;
 	if (upsellId) {
 		$.ajax({
 			type: 'POST',
 			url: '/cart/add.js',
 			data: {
 				quantity: 1,
 				id: upsellId
 			},
 			dataType: 'json',
 			success: function(data) {
 				document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 					bubbles: true
 				}));
 				document.getElementById('mini-cart').open = true;

 				setTimeout(
 					function() {
 						$this.find('span').show();
 						$(".custom_loader").remove();
 					}, 1000);
 				shippingInsuranceAddRemove();
 			}
 		});
 	}

 });

 $(document).ready(function() {
 	$('a.shipping-modal').click(function(e) {
 		e.preventDefault();
 		$('.modal.shipping-modal').css('display', 'block');
 		$('body').css('overflow-y', 'hidden'); //Prevent double scrollbar.
 	});

 	$('.close-modal,.modal-sandbox').click(function(e) {
 		e.preventDefault();
 		$('.modal.shipping-modal').css('display', 'none');
 		$('body').css('overflow-y', 'auto'); //Prevent double scrollbar.
 	});
 	$('a.value-props-modal').click(function(e) {
 		e.preventDefault();
 		$('.modal.value-props-modal').css('display', 'block');
 		$('body').css('overflow-y', 'hidden'); //Prevent double scrollbar.
 	});

 	$('.close-modal,.modal-sandbox').click(function(e) {
 		e.preventDefault();
 		$('.modal.value-props-modal').css('display', 'none');
 		$('body').css('overflow-y', 'auto'); //Prevent double scrollbar.
 	});

 	$('a.guarantee-value-props-modal').click(function(e) {
 		$('.modal.guarantee-value-props-modal').css('display', 'block');
 		$('body').css('overflow-y', 'hidden'); //Prevent double scrollbar.
 	});

 	$('.close-modal,.modal-sandbox').click(function(e) {
 		e.preventDefault();
 		$('.modal.guarantee-value-props-modal').css('display', 'none');
 		$('body').css('overflow-y', 'auto'); //Prevent double scrollbar.
 	});


 });
 //product video
 $(document).ready(function() {

 	$('.product-icon-volume').click(function() {
 		var activeVideo = $('.video-active video')[0];
 		if (activeVideo) {
 			activeVideo.muted = !activeVideo.muted;
 			$(this).toggleClass("volume-muted", activeVideo.muted);
 		}

 	});

 	function playPause(videoId, buttonId) {
 		var myVideo = document.getElementById(videoId);
 		var $button = $("#" + buttonId);

 		// Pause all other videos
 		$('video').not(myVideo).each(function() {
 			this.pause();
 			var otherButtonId = $(this).siblings(".video-control").attr('id');
 			$("#" + otherButtonId).removeClass("btnhide");
 			$("#" + otherButtonId).parents('.popup-video').removeClass('video-active');
 			$("#" + otherButtonId).parents('body').removeClass('video-popup-active');
 		});

 		if (myVideo.paused) {
 			myVideo.play();
 		} else {
 			myVideo.pause();
 		}

 		// Toggle class on the current button
 		$button.toggleClass("btnhide");
 		$button.parents('.popup-video').addClass('video-active');
 		$button.parents('body').addClass('video-popup-active');
 	}

 	function videoClose() {
 		var activeVideo = $('.video-active video')[0];
 		if (activeVideo) {
 			activeVideo.pause(); // Pause the active video
 			var activeButtonId = $(activeVideo).siblings(".video-control").attr('id');
 			$("#" + activeButtonId).removeClass("btnhide"); // Remove "btnhide" class from the button associated with the active video
 		}
 		$('body').removeClass('video-popup-active');
 		$('.popup-video').removeClass('video-active');
 	}

 	$(document).on("click", ".real-review-item .video-control", function() {

 		var clickedControl = $(this);
 		var clickedVideo = clickedControl.closest('.popup-video').find('video')[0];
 		var videoHtml = clickedControl.closest('.video-item').html();

 		// Move the video to the main popup
 		$('.review-main-popup').html(videoHtml);

 		// Pause all other videos
 		$('.popup-video video').not(clickedVideo).each(function() {
 			this.pause();
 			$(this).siblings('.video-control').removeClass('btnhide');
 		});

 		// Toggle play/pause and update control icon for the video in the main popup
 		var mainPopupVideo = $('.review-main-popup video')[0];
 		if (mainPopupVideo.paused) {
 			mainPopupVideo.play();
 			$('.review-main-popup .video-control').addClass('btnhide');
 		} else {
 			mainPopupVideo.pause();
 			$('.review-main-popup .video-control').removeClass('btnhide');
 		}

 		// Activate the main popup
 		$('.review-main-popup').addClass('video-active');
 		$('body').addClass('video-popup-active');
 	});

 	$(document).on("click", ".review-main-popup .icon-close", function() {
 		// Pause and close the video in the main popup
 		var mainPopupVideo = $('.review-main-popup video')[0];
 		if (mainPopupVideo) {
 			mainPopupVideo.pause();
 			$('.review-main-popup .video-control').removeClass('btnhide');
 		}

 		$('body').removeClass('video-popup-active');
 		$('.review-main-popup').removeClass('video-active');
 		$('.review-main-popup').empty();
 	});

 	$(document).on("click", ".review-main-popup .icon-volume", function() {
 		console.log("this = ", this);
 		var mainPopupVideo = $(this).parents('.review-main-popup').find('video')[0];
 		console.log("mainPopupVideo", mainPopupVideo);
 		if (mainPopupVideo) {
 			mainPopupVideo.muted = !mainPopupVideo.muted;
 			$(this).toggleClass("volume-muted", mainPopupVideo.muted);
 		}
 	});


 	$(document).on("click", ".review-tab-item", function() {
 		$(this).addClass('active');
 		$(this).siblings().removeClass('active');
 		var dataTab = $(this).data('href');
 		$(dataTab).addClass('active');
 		$(dataTab).siblings().removeClass('active');
 	});


 	if ($(".main-video-inner").length > 0) {
 		$(".main-video-inner").slick({
 			infinite: true,
 			slidesToShow: 3,
 			slidesToScroll: 1,
 			arrows: false,
 			responsive: [{
 				breakpoint: 741,
 				settings: {
 					slidesToShow: 2,
 					slidesToScroll: 1,
 				}
 			}]
 		});
 	}
 	if ($(".trust_review_slider").length > 0) {
 		$(".trust_review_slider").slick({
 			infinite: true,
 			slidesToShow: 3,
 			slidesToScroll: 1,
 			arrows: true,
 			responsive: [{
 					breakpoint: 1200,
 					settings: {
 						slidesToShow: 2,
 						slidesToScroll: 1,
 					}
 				},
 				{
 					breakpoint: 768,
 					settings: {
 						slidesToShow: 1,
 						slidesToScroll: 1,
 					}
 				}
 			]
 		});
 	}
 });

 document.addEventListener('variant:changed', function(event) {
 	let variant = event.detail.variant; // Gives you access to the whole variant details
 	let varTitle = variant.title;
 	console.log(varTitle);
 	let freegifts = 0;
 	switch (varTitle) {
 		case '1 Frasco':
 			freegifts = 1;
 			break;
 		case '2 Frascos':
 			freegifts = 2;
 			break;

 		case '3 Frascos':
 			freegifts = 3;
 			break;

 		case '4 Frascos':
 			freegifts = 4;
 			break;

 		default:
 			break;
 	}
 	var freeGifsDom = $('.free-gift-flex .free-gift-scooper');
 	$('.free-gift-flex .free-gift-scooper').removeClass('active');
 	$('.free-gift-flex .free-gift-scooper').find('input').attr("disabled", true);
 	for (var i = 0; i < freegifts; i++) {
 		$(freeGifsDom[i]).addClass('active');
 	}
 	$('.free-gift-flex .free-gift-scooper.active').find('input').attr("disabled", false);
 	$('#StickyAddToCart').addClass('main-atc-button--js');
 	$('#StickyAddToCart.main-atc-button--js').find('.loader-button__text').text('Agregar al carrito');

 	$('.free-gifts-properties-js').empty();

 	$('form.free-gifts-form.active input.js-product_id_input:not(:disabled)').each(function(index, data) {
 		var value = $(this).val();
 		var newInput = `<input type="hidden" name="properties[_free gift ${index}]" value= "${value}">`;
 		// console.log(newInput);
 		$('.free-gifts-properties-js').append(newInput);

 	});

 });

 function lockScroll() {
 	$html = $('html');
 	$body = $('body');
 	var initWidth = $body.outerWidth();
 	var initHeight = $body.outerHeight();

 	var scrollPosition = [
 		self.pageXOffset || document.documentElement.scrollLeft || document.body.scrollLeft,
 		self.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
 	];
 	$html.data('scroll-position', scrollPosition);
 	$html.data('previous-overflow', $html.css('overflow'));
 	$html.css('overflow', 'hidden');
 	window.scrollTo(scrollPosition[0], scrollPosition[1]);

 	var marginR = $body.outerWidth() - initWidth;
 	var marginB = $body.outerHeight() - initHeight;
 	$body.css({
 		'margin-right': marginR,
 		'margin-bottom': marginB
 	});
 }

 function unlockScroll() {
 	$html = $('html');
 	$body = $('body');
 	$html.css('overflow', $html.data('previous-overflow'));
 	var scrollPosition = $html.data('scroll-position');
 	window.scrollTo(scrollPosition[0], scrollPosition[1]);

 	$body.css({
 		'margin-right': 0,
 		'margin-bottom': 0
 	});
 }

 $(document).on('click', '.main-atc-button--js', function(e) {
 	e.preventDefault();
 	e.stopPropagation();
 	$('#customAddToCart').click();
 	var $this = $(this);

 	$this.addClass('processing');
 	$this.find('span.loader-button__text').css('opacity', '0');
 	$this.find('span.loader-button__loader').addClass('show');
 	setTimeout(function() {
 		$this.find('span.loader-button__text').css('opacity', '1');
 		$this.find('span.loader-button__loader').removeClass('show');
 		$this.removeClass('processing');
 	}, 1500);

 });

 $('#customAddToCart').click(function(e) {
 	e.preventDefault();
 	$(this).find('span.loader-button__text').hide();
 	$(this).find('span.loader-button__loader').css('display', 'contents');
 	let addToCartForm = document.querySelector('form.free-gifts-form.active');
 	let formData = new FormData(addToCartForm);
 	$('form.free-gifts-form.active input.js-product_id_input:not(:disabled)').each(function(index, data) {
 		var value = $(this).val();
 		var newInput = `<input type="hidden" name="properties[_free gift ${index}]" value= "${value}">`;
 		// console.log(newInput);
 		$('.free-gifts-properties-js').append(newInput);

 	});
 	$.ajax({
 		type: "POST",
 		url: '/cart/clear.js',
 		data: '',
 		dataType: 'json',
 		success: function() {
 			document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 				bubbles: true
 			}));
 			fetch(window.Shopify.routes.root + 'cart/add.js', {
 					method: 'POST',
 					body: formData
 				})
 				.then(response => {
 					$('#AddToCart').click();
 					// document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 					//              bubbles: true
 					//             }));

 					// return response.json();
 				})
 				.catch((error) => {
 					alert(error);
 					console.error('Error:', error);
 				});
 			setTimeout(function() {
 				$('#customAddToCart').find('span.loader-button__text').show();
 				$('#customAddToCart').find('span.loader-button__loader').hide();
 			}, 1000);
 		},
 		error: function(XMLHttpRequest, textStatus) {
 			/* error code */
 		}
 	});

 });


 // Code below has been updated by Naveed to resolve the cart drawer issue .

 //   document.addEventListener('cart:updated', function(event) {
 //     var cart = event.detail.cart; 
 //     console.log(cart,"Cart Update **********************");
 //         checkAndRefreshCartDrawer(cart);
 // });

 // function checkAndRefreshCartDrawer(cart) {

 //     var freeGiftProductHandles = ['free-ebook-sca_clone_freegift', 'free-shipping-1-sca_clone_freegift', 'free-lash-curler-sca_clone_freegift', 'free-mascara-sca_clone_freegift'];

 //     var anyFreeGiftsInCart = freeGiftProductHandles.some(function(handle) {
 //         return cart.items.some(function(item) {
 //             return item.handle === handle;
 //         });
 //     });


 //     var drawerContainsFreeGift = freeGiftProductHandles.some(function(handle) {
 //         return $('.drawer__content').find(`[data-cart-item-handle="${handle}"]`).length > 0;
 //     });

 //     if ((anyFreeGiftsInCart && !drawerContainsFreeGift) || (!anyFreeGiftsInCart && drawerContainsFreeGift)) {

 //         document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 //           bubbles: true
 //         }));
 //       console.log('Cart drawer refreshed due to a mismatch between the cart and the drawer.');
 //     } else {

 //         console.log('Cart and drawer are in sync. No refresh needed.');
 //     }
 // }




 // function isCart() {
 //   if (document.URL.includes("cart")) return true;
 //   else false;
 // }

 //   $(document).on('click', '.line-item__remove-button.main-product--true', function(e){
 //        e.preventDefault();
 //     var updates = {};
 //     updates[$(this).data('line-id')] = 0;
 //     $('.product-item-meta__property input.freegiftId').each(function(index,data) {
 //       var isLastElement = index == data.length -1;
 //       let vId = $(this).val();
 //       updates[$(this).val()] = 0;
 //          // jQuery.post('/cart/change.json', { quantity: 0, id: vId })
 //          //  .done(function() {
 //          //    console.log(" Free gift -  removed");
 //          //     if (isLastElement) {
 //          //    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 //          //        bubbles: true
 //          //     }));
 //          //     }
 //          //                   })
 //   });

 //     fetch(window.Shopify.routes.root + 'cart/update.js', {
 //       method: 'POST',
 //       headers: {
 //         'Content-Type': 'application/json'
 //       },
 //       body: JSON.stringify({ updates })
 //     })
 //     .then(response => {
 //       if (isCart()) {
 //       location.reload();
 //     } else {
 //       document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 //                 bubbles: true
 //              }));
 //       return response.json();
 //       }
 //     })
 //     .catch((error) => {
 //       console.error('Error:', error);
 //     });

 //       });

 $(".scroll-to-bundle--js").click(function(e) {
 	e.preventDefault();
 	$('html,body').animate({
 			scrollTop: $(".product_bundle_wrapper").offset().top - 160
 		},
 		'slow');
 });

 $(".scroll-to-product-form--js").click(function(e) {
 	e.preventDefault();
 	$('html,body').animate({
 			scrollTop: $(".product__info").offset().top - 160
 		},
 		'slow');
 });

 $('.bundle-atc-custom').click(function(e) {
 	e.preventDefault();
 	var $this = $(this);
 	$this.addClass('button--loading');
 	$this.find('span.loader-button__text').hide();
 	$this.find('span.loader-button__loader').css('display', 'contents');

 	$.ajax({
 		type: "POST",
 		url: '/cart/clear.js',
 		data: '',
 		dataType: 'json',
 		success: function() {
 			document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 				bubbles: true
 			}));
 			$this.next('.bundle-atc-custom--main').click();
 			setTimeout(function() {
 				$this.removeClass('button--loading');
 				$this.find('span.loader-button__text').show();
 				$this.find('span.loader-button__loader').hide();
 			}, 1000);
 		},
 		error: function(XMLHttpRequest, textStatus) {
 			/* error code */
 		}
 	});

 });

 function isElementInViewport(el) {
 	var rect = el.getBoundingClientRect();
 	return (
 		rect.top >= 0 &&
 		rect.left >= 0 &&
 		rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
 		rect.right <= (window.innerWidth || document.documentElement.clientWidth)
 	);
 }

 // $(window).scroll(function() {
 //     var scrollPosition = $(this).scrollTop();
 //     var productBundleSection = $('.product_bundle_section')[0];
 //     var customProductForm = $('.custom-product-sticky-form');

 //     if (scrollPosition > 500 || isElementInViewport(productBundleSection)) {
 //         customProductForm.removeAttr('hidden'); // Remove the hidden attribute when productBundleSection is in viewport
 //     } else {
 //         customProductForm.attr('hidden', true); // Add the hidden attribute otherwise
 //     }
 // });

 // // Function to check if an element is in the viewport
 // function isElementInViewport(el) {
 //     var rect = el.getBoundingClientRect();
 //     return (
 //         rect.top >= 0 &&
 //         rect.left >= 0 &&
 //         rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
 //         rect.right <= (window.innerWidth || document.documentElement.clientWidth)
 //     );
 // }
 $(window).scroll(function() {
 	if ($(this).scrollTop() > 500) {
 		$('.custom-product-sticky-form').removeAttr('hidden');
 	} else {
 		$('.custom-product-sticky-form').attr('hidden', true);
 	}
 });

 $(window).scroll(function() {
 	if ($('.product_bundle_section').length) {
 		var viewportTopBundle = $(window).scrollTop();
 		var viewportBottomBundle = viewportTopBundle + $(window).height();
 		var elementTopBundle = $('.product_bundle_section').offset().top;
 		var elementBottomBundle = elementTopBundle + $('.product_bundle_section').outerHeight();

 		// Check if the element is in the viewport
 		if ((elementBottomBundle >= viewportTopBundle) && (elementTopBundle <= viewportBottomBundle)) {
 			// If the element is in the viewport, trigger alert
 			$('.custom-product-sticky-form').attr('hidden', true);
 		}
 	}
 });


 $(document).ready(function() {
 	var lastScrollTop = 0;

 	$(window).scroll(function() {
 		var currentScrollTop = $(this).scrollTop();

 		if (currentScrollTop < lastScrollTop) {
 			// Scrolling up
 			$('.scroll-top').addClass('scroll-top--active');
 		} else {
 			// Scrolling down
 			$('.scroll-top').removeClass('scroll-top--active');
 		}

 		lastScrollTop = currentScrollTop;
 	});

 	if ($('#stock-number').length) {

 		function updateStockNumber() {
 			let stockNumber = document.getElementById('stock-number');
 			let currentNumber = parseInt(stockNumber.innerText);
 			let decreaseAmount = Math.floor(Math.random() * 5) + 1; // Random decrease between 1 and 5
 			let newNumber = currentNumber - decreaseAmount;

 			if (newNumber > 0) {
 				stockNumber.innerText = newNumber;
 			} else {
 				// Restart the counter from the starting value
 				parseInt(stockNumber.getAttribute('data-order'));
 			}
 		}

 		// Initial update after 2-3 seconds
 		setTimeout(updateStockNumber, Math.floor(Math.random() * 2001) + 2000); // Random time between 2000ms and 4000ms

 		// Random updates every 5 seconds
 		setInterval(() => {
 			setTimeout(updateStockNumber, Math.floor(Math.random() * 3001) + 2000); // Random time between 2000ms and 5000ms
 		}, 5000);
 	}

 });



 // Menu drawer js
 $(document).ready(function() {
 	$('.mobile-item-title').on('click', function() {
 		$(this).parents('.mobile-nav__item_new').addClass('menu-active');
 		$(this).parents('.mobile-nav__item_new').siblings().removeClass('menu-active');

 	});



 	$('.drawer__close-button').on('click', function() {
 		$('.mobile-nav__item_new').removeClass('menu-active');
 	});


 	$('.mobile-item-title-v3').click(function() {
 		$(this).siblings('.menu-item-content-v3').slideToggle();
 		$(this).find('.has_sub_icon svg').toggle();
 	});

 	$('.tab_heading_item').click(function() {
 		$(this).addClass('active');
 		$(this).siblings().removeClass('active');
 		var menuTarget = $(this).data('tab');
 		$(this).parents('.mobile_menu_tab').find('.nav_tab_content #' + menuTarget).addClass('active');
 		$(this).parents('.mobile_menu_tab').find('.nav_tab_content #' + menuTarget).siblings().removeClass('active');
 	});

 	$(document).on('click', '.click_gift', function() {
 		var $this = $(this);
 		shippingInsuranceAddRemoveCall($this);
 		console.log("function call==================");
 	});
 });

 function shippingInsuranceAddRemoveCall($this) {
 	var shippingInsurance = false;
 	var shippingHandle = 'shipping-insurance-coverage-for-lost-packages-of-up-to-250-v1';
 	var shippingID = '44486626836532';
 	$.ajax({
 		type: 'GET',
 		url: '/cart.json',
 		dataType: 'jsonp',
 		success: function(data) {
 			var items = data['items'];
 			for (var i = 0; i < items.length; i++) {
 				if (items[i]["handle"] == shippingHandle) {
 					shippingInsurance = true;
 				}
 			}
 			if (items.length >= 1) {
 				if ($this.is(':checked')) {
 					if (!shippingInsurance) {
 						shippingAddProduct(shippingID);
 					}
 				} else {
 					shippingRemoveProduct(shippingID);
 				}
 			}
 		}
 	});
 }

 function shippingAddProduct(variantID) {
 	var xhr = new XMLHttpRequest();
 	var url = "/cart/add.js";
 	xhr.open("POST", url, true);
 	xhr.setRequestHeader("Content-Type", "application/json");

 	xhr.onreadystatechange = function() {
 		if (xhr.readyState === 4) {
 			if (xhr.status === 200) {
 				if (window.location.href.indexOf("cart") > -1) {
 					location.reload();
 				}
 				document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 					bubbles: true
 				}));
 				// updateCartBubble();
 				$('.click_gift').prop('checked', true);
 			} else {
 				console.error('Error adding product to cart:', xhr.status, xhr.statusText);
 			}
 		}
 	};

 	var data = JSON.stringify({
 		"quantity": 1,
 		"id": variantID
 	});

 	xhr.send(data);
 }

 function shippingRemoveProduct(shippingID) {
 	var variantIDString = shippingID.toString();
 	var xhr = new XMLHttpRequest();
 	var url = "/cart/change.js";
 	xhr.open("POST", url, true);
 	xhr.setRequestHeader("Content-Type", "application/json");

 	xhr.onreadystatechange = function() {
 		if (xhr.readyState === 4) {
 			if (xhr.status === 200) {
 				if (window.location.href.indexOf("cart") > -1) {
 					location.reload();
 				}
 				document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 					bubbles: true
 				}));
 				// updateCartBubble();
 				$('.click_gift').prop('checked', false);
 			} else {
 				console.error('Error removing product from cart:', xhr.status, xhr.statusText);
 			}
 		}
 	};

 	var data = JSON.stringify({
 		"id": variantIDString,
 		"quantity": 0
 	});

 	xhr.send(data);
 }


 // lip plumper Variant Dropdown
 $('.custom_variaent_select').change(function() {
 	var variantImg = $(this).find('option:selected').data('variantimg');
 	var variantDesc = $(this).find('option:selected').data('variantdesc');
 	var variantValue = $(this).find('option:selected').data('variantvalue');
 	var selectVariantId = $(this).find('option:selected').data('selectvariantid');
 	var mainImgId = $(this).find('option:selected').data('mainimgid');
 	var mainFirstImg = $(this).find('option:selected').data('mainfirstimg');
 	var mainSecondImg = $(this).find('option:selected').data('mainsecondimg');
 	var mainMediaId = $(this).find('option:selected').data('mediaid');


 	// Change Select Box 

 	setTimeout(function() {
 		console.log("clicked version=====================", $('.comboBox_button').find('.select__selected-value').length);
 		$('.comboBox_button').find('.select__selected-value').html(`<span class="img-wrap"><img src="${variantImg}" alt=""></span><span class="text"><span class="name">${variantValue}</span> <span class="desc">${variantDesc}</span></span>`);
 	}, 0);

 	// Change Product Thumbnail 
 	$('.product__thumbnail-item.is-variantImg').removeClass('active');
 	$(this).parents('.product').find('.product__thumbnail-item[data-variantitem="' + selectVariantId + '"]').prop('aria-current', '');
 	$(this).parents('.product').find('.product__thumbnail-item[data-variantitem="' + selectVariantId + '"]').addClass('active');
 	$(this).parents('.product').find('.product__thumbnail-item.variant-first_img[data-variantitem="' + selectVariantId + '"]').attr('aria-current', true);

 	// Change Main Image 
 	$(this).parents('.product').find('.main-second-image').attr('id', mainImgId + '-2').attr('data-media-id', mainMediaId);
 	$(this).parents('.product').find('.main-second-image img').attr('src', mainSecondImg).attr('srcset', mainSecondImg);

 	$(this).parents('.product').find('.main-first-image').attr('id', mainImgId).attr('data-media-id', mainMediaId);
 	$(this).parents('.product').find('.main-first-image img').attr('src', mainFirstImg).attr('srcset', mainFirstImg);



 });


 $(document).ready(function() {
 	// Product Upsell 1
 	$('.upsell-version-1 .upsell_slider_list').slick({
 		slidesToShow: 2,
 		dots: false,
 		arrows: true,
 		appendArrows: '.upsell_nav1',
 		responsive: [{
 			breakpoint: 768,
 			settings: {
 				slidesToShow: 3,
 			}
 		}]
 	});



 	// Product Upsell 1
 	$('.upsell-version-2 .upsell_slider_list').slick({
 		slidesToShow: 2,
 		dots: false,
 		arrows: true,
 		appendArrows: '.upsell_nav2',
 		responsive: [{
 			breakpoint: 768,
 			settings: {
 				slidesToShow: 3,
 			}
 		}]
 	});


 });



 function shippingInsuranceAddRemove() {
 	if ($('body').hasClass("shipping-insurance")) {
 		var shippingInsurance = false;
 		var shippingHandle = 'shipping-insurance-coverage-for-lost-packages-of-up-to-250-v1';
 		var shippingID = '44486626836532';
 		var $this = $(this);
 		$.ajax({
 			type: 'GET',
 			url: '/cart.json',
 			dataType: 'jsonp',
 			success: function(data) {
 				var items = data['items'];
 				for (var i = 0; i < items.length; i++) {
 					if (items[i]["handle"] == shippingHandle) {
 						shippingInsurance = true;
 					}
 				}
 				if (items.length >= 1) {
 					if (!shippingInsurance) {
 						shippingAddProduct(shippingID);
 						setTheCookie("ShippingProtection", "1", 1);
 						console.log("shippingInsurance true=====================");
 					}
 				}
 				if (shippingInsurance) {
 					if (items.length == 1) {
 						shippingRemoveProduct(shippingID);
 					}
 				}
 			}
 		});
 	}
 }

 function shippingInsuranceRemoveOnQuantityChange() {
 	var shippingInsurance = false;
 	var shippingHandle = 'shipping-insurance-coverage-for-lost-packages-of-up-to-250-v1';
 	var shippingID = '44486626836532';
 	$.ajax({
 		type: 'GET',
 		url: '/cart.json',
 		dataType: 'jsonp',
 		success: function(data) {
 			var items = data['items'];
 			for (var i = 0; i < items.length; i++) {
 				if (items[i]["handle"] == shippingHandle) {
 					shippingInsurance = true;
 				}
 			}
 			if (items.length == 1) {
 				if (shippingInsurance) {
 					shippingRemoveProduct(shippingID);
 				}
 			}
 		}
 	});
 }

 function shippingAddProduct(variantID) {
 	var xhr = new XMLHttpRequest();
 	var url = "/cart/add.js";
 	xhr.open("POST", url, true);
 	xhr.setRequestHeader("Content-Type", "application/json");

 	xhr.onreadystatechange = function() {
 		if (xhr.readyState === 4) {
 			if (xhr.status === 200) {
 				if (window.location.href.indexOf("cart") > -1) {
 					location.reload();
 				}
 				document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 					bubbles: true
 				}));
 				// updateCartBubble();
 				$('.click_gift').prop('checked', true);
 			} else {
 				console.error('Error adding product to cart:', xhr.status, xhr.statusText);
 			}
 		}
 	};

 	var data = JSON.stringify({
 		"quantity": 1,
 		"id": variantID
 	});

 	xhr.send(data);
 }

 function shippingRemoveProduct(shippingID) {
 	var variantIDString = shippingID.toString();
 	var xhr = new XMLHttpRequest();
 	var url = "/cart/change.js";
 	xhr.open("POST", url, true);
 	xhr.setRequestHeader("Content-Type", "application/json");

 	xhr.onreadystatechange = function() {
 		if (xhr.readyState === 4) {
 			if (xhr.status === 200) {
 				if (window.location.href.indexOf("cart") > -1) {
 					location.reload();
 				}
 				document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 					bubbles: true
 				}));
 				// updateCartBubble();
 				$('.click_gift').prop('checked', false);
 			} else {
 				console.error('Error removing product from cart:', xhr.status, xhr.statusText);
 			}
 		}
 	};

 	var data = JSON.stringify({
 		"id": variantIDString,
 		"quantity": 0
 	});

 	xhr.send(data);
 }




 // // Upsell Version 1
 // document.addEventListener("DOMContentLoaded", function(event) {
 //   var upsellVersion = document.getElementsByClassName('product_upsell_main')[0];
 //   upsellVersion.classList.add('upsell-item-1');
 // });

 // // Upsell Version 2
 // document.addEventListener("DOMContentLoaded", function(event) {
 //   var upsellVersion = document.getElementsByClassName('product_upsell_main')[0];
 //   upsellVersion.classList.add('upsell-item-2');
 // });


 document.addEventListener('DOMContentLoaded', function() {
 	const toggle = document.querySelector('.subscription-toggle');
 	const form = document.querySelector('.shopify-product-form');

 	if (!toggle || !form) return;

 	function handleSellingPlanInput() {
 		const existingInput = form.querySelector('input[name="selling_plan"]');

 		if (toggle.classList.contains('active')) {
 			if (!existingInput) {
 				const input = document.createElement('input');
 				input.type = 'hidden';
 				input.name = 'selling_plan';
 				input.value = '';
 				form.appendChild(input);
 			}
 		} else if (existingInput) {
 			existingInput.remove();
 		}
 	}

 	// Run once on page load
 	handleSellingPlanInput();

 	const observer = new MutationObserver(handleSellingPlanInput);
 	observer.observe(toggle, {
 		attributes: true,
 		attributeFilter: ['class']
 	});
 });

// product sticky add to cart
 $('.product-sticky-form .product-form__add-button').on("click", function() {
	  $('.product__info .product-form__buy-buttons .product-form__add-button').trigger('click');
 });


function fixDiscountLabels() {
  document.querySelectorAll('[data-product-label-list] .label--highlight').forEach(label => {
    const wrapper = label.closest('[data-product-label-list]');
    const saveText = wrapper?.dataset?.saveText?.trim() || 'Ahorra';

    // Skip if label already contains the translated text
    if (label.textContent.toLowerCase().includes(saveText.toLowerCase())) {
      return;
    }

    const firstSpan = label.querySelector('span');

    if (firstSpan) {
      firstSpan.textContent = `${saveText} ${firstSpan.textContent}`.trim();
    } else {
      label.innerHTML = `${saveText} ${label.innerHTML}`;
    }
  });
}

fixDiscountLabels();

new MutationObserver(fixDiscountLabels).observe(document.body, {
  childList: true,
  subtree: true
});